import React from 'react';

const BipolarsPageComponent = () => {
  return (
    <div className="container my-5">
      <div className="row justify-content-center">
        <div className="col-11 card pb-4 border-0">
          <div className="row">
            <div className="col p-4">
              <h1>Linear Systems Bipolar Transistor Product Line</h1>

              <p>
                For more information, please contact <a href="mailto:sales@linearsystems.com" rel="noopener noreferrer" target="_blank">sales@linearsystems.com</a> or call (510) 490-9160.
              </p>

              <p>Featuring:</p>
              <ul>
                <li>Complementary Tightly Matching, Monolithic Dual and Single NPN and PNP Devices.</li>
                <li>Direct replacements for the Analog Devices MAT series</li>
                <li>High current gain (hfe) and Low offset (Vbe) and low temperature drift</li>
                <li>Ideal for Tight Matching, Small Signal, Amplifier and Switching Applications.</li>
                <li>Available in PDIP 8L ROHS, TO-71 6L ROHS, TO-78 6L ROHS, SOIC 8L ROHS, SOT-23 6L ROHS, DFN 8L and Tested Die.</li>
                <li>All Linear Systems devices are available with special testing and screening to customer specifications. </li>
                <li>SPICE models are available for most parts.</li>
              </ul>

              <hr />

              <h3>Our Premier Monolithic Dual Bipolar Transistors</h3>

              <h4>LS310 Low Noise Series</h4>
              <p>
              The LS310 Series (LS310/311/312/313) is a line of Tightly Matched, Monolithic Dual, NPN Transistors that are direct replacements for Analog Devices MAT series and National LM3494 series. These parts are ideal for Tight Matching, Small Signal Transistor Amplifier and Switching Applications. Available in PDIP 8L ROHS, TO-71 6L ROHS, TO-78 6L ROHS, SOIC 8L ROHS, SOT-23 6L ROHS, DFN 8L and Tested Die.
              </p>
              <p>
                <a className="btn btn-primary" href="https://linearsystems.com/lsdata/datasheets/LS310,%20LS311,%20LS312,%20LS313%20MONOLITHIC%20DUAL%20NPN%20TRANSISTORS.pdf">Datasheet</a> &nbsp;
                <a className="btn btn-primary" href="https://linearsystems.com/lsdata/spicemodel/Copy_SST310%20NJF.txt">SPICE Model</a>
              </p>
              <p>
                Both these parts are available in single form.
              </p>

              <h4>LS350 Low Noise Series</h4>
              <p>
                The LS350 Series (LS350/351/352) is a line of Tightly Matched, Monolithic Dual, PNP Transistors that are direct replacements for Analog Devices MAT series and National LM3494 series. These parts are ideal for Tight Matching, Small Signal Transistor Amplifier and Switching Applications. Available in PDIP 8L ROHS, TO-71 6L ROHS, TO-78 6L ROHS, SOIC 8L ROHS, SOT-23 6L ROHS, DFN 8L and Tested Die.
              </p>
              <p>
                <a className="btn btn-primary" href="https://linearsystems.com/lsdata/datasheets/LS350_351_352_Tightly_Matched,_Monolithic_Dual,_PNP_Transistor.pdf">Datasheet</a> &nbsp;
                <a className="btn btn-primary" href="https://linearsystems.com/lsdata/spicemodel/transistorsls350familyspicemodels.zip">SPICE Model</a>
              </p>
              <p>
                Both these parts are available in single form.
              </p>

              <h4>LS3250 Low Noise</h4>
              <p>
                The LS3250 Tightly Matched, Monolithic Dual, NPN Transistor is a Higher Current Version of the MP310, MP311, MP312, and MP313 Series. It is ideal for Higher Current, Small Signal Transistor, Super Beta, Amplifier and Switching Applications. Available in PDIP 8L ROHS, TO-71 6L ROHS, TO-78 6L ROHS, SOIC 8L ROHS, SOT-23 6L ROHS, and Tested Die. All Linear Systems devices are available with special testing to customer specification.
              </p>
              <p>
                <a className="btn btn-primary" href="https://linearsystems.com/lsdata/datasheets/LS3250A_LS3250B_LS3250C_Higher_Current,_Monolithic_Dual,_NPN_Transistor.pdf">Datasheet</a> &nbsp;
                <a className="btn btn-primary" href="https://linearsystems.com/lsdata/spicemodel/transistorsls3250familyspicemodels.zip">SPICE Model</a>
              </p>

              <h4>LS3550 Low Noise</h4>
              <p>
                The LS3550 Tight Matched, Monolithic Dual, PNP Transistor is a Higher Current Version of the MP350, MP 351, and MP352 Series. It is ideal for Small Signal Transistor, Super Beta Amplifier and Switching Applications. Available in PDIP 8L ROHS, TO-71 6L ROHS, TO-78 6L ROHS, SOIC 8L ROHS, SOT-23 6L ROHS, and Tested Die. All Linear Systems devices are available with special testing to customer specification.
              </p>
              <p>
                <a className="btn btn-primary" href="https://linearsystems.com/lsdata/datasheets/LS3550A_LS3550B_LS3550C_Higher_Current,_Monolithic_Dual,_PNP_Transistor.pdf">Datasheet</a> &nbsp;
                <a className="btn btn-primary" href="https://linearsystems.com/lsdata/spicemodel/transistorsls3550familyspicemodels.zip">SPICE Model</a>
              </p>

              <h4>LS120A</h4>
              <p>
                The IT120A Series (LS120/121/122) Monolithic Dual, NPN Transistor is a direct replacement for the Intersil IT120 Series. It is ideal for Small Signal Transistor Amplifier and Switching Applications. Available in PDIP 8L ROHS, TO-71 6L ROHS, TO-78 6L ROHS, SOIC 8L ROHS, and Tested Die. All Linear Systems devices are available with special testing to customer specification.
              </p>
              <p>
                <a className="btn btn-primary" href="https://linearsystems.com/lsdata/datasheets/IT120A_IT120_IT121_IT122_Tightly_Matched,_Monolithic_Dual,_NPN_Transistor.pdf">Datasheet</a> &nbsp;
                <a className="btn btn-primary" href="https://linearsystems.com/lsdata/spicemodel/transistorsls310familyspicemodels.zip">SPICE Model</a>
              </p>

              <h4>LS124</h4>
              <p>
                The IT124 Monolithic Dual, NPN Transistor, Super Beta is a direct replacement for Intersil IT124. It is ideal for Small Signal Transistor, Super Beta, Amplifier and Switching Applications. Available in PDIP 8L ROHS, TO-71 6L ROHS, SOIC 8L ROHS, and Tested Die. All Linear Systems devices are available with special testing to customer specification.
              </p>
              <p>
                <a className="btn btn-primary" href="https://linearsystems.com/lsdata/datasheets/IT124_LS124_High_Voltage,_Super_Beta,_Monolithic_Dual,_NPN_Transistor.pdf">Datasheet</a> &nbsp;
                <a className="btn btn-primary" href="https://linearsystems.com/lsdata/spicemodel/transistorsls301familyspicemodels.zip">SPICE Model</a>
              </p>

              <h4>LS130</h4>
              <p>
                The IT130A Series Monolithic Dual, PNP Transistor is a direct replacement for Intersil IT130 Series. It is ideal for Small Signal Transistor Amplifier & Switching Applications. Available in PDIP 8L ROHS, TO-71 6L ROHS, TO-78 6L ROHS, SOIC 8L ROHS, and Tested Die. All Linear Systems devices are available with special testing to customer specification.
              </p>
              <p>
                <a className="btn btn-primary" href="https://linearsystems.com/lsdata/datasheets/IT130A_IT130_IT131_IT132_Tightly_Matched,_Monolithic_Dual,_PNP_Transistor.pdf">Datasheet</a> &nbsp;
                <a className="btn btn-primary" href="https://linearsystems.com/lsdata/spicemodel/transistorsls350familyspicemodels.zip">SPICE Model</a>
              </p>

              <h4>LS311</h4>
              <p>
                The LS310 Series Tightly Matched, Monolithic Dual, NPN Transistor is a direct replacement for Analog Devices MAT series and National LM3494 series. It is ideal for Tight Matching, Small Signal Transistor Amplifier and Switching Applications. Available in PDIP 8L ROHS, TO-71 6L ROHS, TO-78 6L ROHS, SOIC 8L ROHS, SOT-23 6L ROHS, and Tested Die. All Linear Systems devices are available with special testing to customer specification.
              </p>
              <p>
                <a className="btn btn-primary" href="https://linearsystems.com/lsdata/datasheets/LS310,%20LS311,%20LS312,%20LS313%20MONOLITHIC%20DUAL%20NPN%20TRANSISTORS.pdf">Datasheet</a> &nbsp;
                <a className="btn btn-primary" href="https://linearsystems.com/lsdata/spicemodel/transistorsls310familyspicemodels.zip">SPICE Model</a>
              </p>

              <h4>LS318</h4>
              <p>
                The LS318 Log Conformance, Monolithic Dual, NPN Transistor is a direct replacement for Micro Power Systems MP318 Series. It is ideal for Log Conformance, Transistors Amplifier and Switching Applications. Available in PDIP 8L ROHS, TO-71 6L ROHS, TO-78 6L ROHS, SOIC 8L ROHS, and Tested Die. All Linear Systems devices are available with special testing to customer specification.
              </p>
              <p>
                <a className="btn btn-primary" href="https://linearsystems.com/lsdata/datasheets/LS318_Log_Conformance,_Monolithic_Dual,_NPN_Transistor.pdf">Datasheet</a> &nbsp;
                <a className="btn btn-primary" href="https://linearsystems.com/lsdata/spicemodel/transistorsls318familyspicemodels.zip">SPICE Model</a>
              </p>

              <h4>LS358</h4>
              <p>
                The LS358 Log Conformance, Monolithic Dual, PNP Transistor is a direct replacement for Micro Power Systems MP358 Series. It is ideal for Log Conformance, Transistor Amplifier and Switching Applications. Available in PDIP 8L ROHS, TO-71 6L ROHS, TO-78 6L ROHS, SOIC 8L ROHS, and Tested Die. All Linear Systems devices are available with special testing to customer specification.
              </p>
              <p>
                <a className="btn btn-primary" href="https://linearsystems.com/lsdata/datasheets/LS358_Log_Conformance,_Monolithic_Dual,_PNP_Transistor.pdf">Datasheet</a> &nbsp;
                <a className="btn btn-primary" href="https://linearsystems.com/lsdata/spicemodel/transistorsls358familyspicemodels.zip">SPICE Model</a>
              </p>

              <h4>LS301</h4>
              <p>
                The LS301 Series High Voltage, Super Beta, Monolithic Dual, NPN Transistor is a direct replacement for Micro Power Systems MP301, MP302, MP303 Series. It is ideal for Small Signal Transistors, Super Beta, Amplifier and Switching Applications. Available in PDIP 8L ROHS, TO-71 6L ROHS, TO-78 6L ROHS, SOIC 8L ROHS and Tested Die. All Linear Systems devices are available with special testing to customer specification.
              </p>
              <p>
                <a className="btn btn-primary" href="https://linearsystems.com/lsdata/datasheets/LS301_LS302_LS303_High_Voltage,_Super_Beta,_Monolithic_Dual,_NPN_Transistor.pdf">Datasheet</a> &nbsp;
                <a className="btn btn-primary" href="https://linearsystems.com/lsdata/spicemodel/transistorsls301familyspicemodels.zip">SPICE Model</a>
              </p>

              <hr />

              <p>
                For more information, please contact <a href="mailto:sales@linearsystems.com" rel="noopener noreferrer" target="_blank">sales@linearsystems.com</a> or call (510) 490-9160.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BipolarsPageComponent;
